const content = [require("./5/index").default];

export default content;
